import { LuX } from 'react-icons/lu'
import TrustpilotWidget from './TrustpilotWidget.jsx'
import ReviewsIoWidget from './ReviewsIoWidget.jsx'
import FeefoWidget from './FeefoWidget.jsx'

const BUSINESS_TYPE_LABELS = {
  conveyencer: 'Conveyancing',
  'mortgage-broker': 'Mortgage broker',
  photographer: 'Photography / Videography',
  'moving-or-storage': 'Removals & storage',
  'floorplan-services': 'Floorplans',
  advertiser: 'Partner',
}

const PartnerAdvertModal = ({
  partner,
  form,
  onFormChange,
  onSubmit,
  onClose,
  submitting,
  error,
  success,
  successMessage,
}) => {
  if (!partner) return null

  return (
    <div className="buyer-modal" role="dialog" aria-modal="true" aria-label={`${partner.name} — request a callback`}>
      <div className="buyer-modal__content" style={{ maxWidth: '540px' }}>
        <header className="buyer-modal__header">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <p className="search-hero__eyebrow" style={{ margin: 0 }}>Sponsored partner</p>
              {partner.businessType && (
                <span className="pill" style={{ whiteSpace: 'nowrap' }}>
                  {BUSINESS_TYPE_LABELS[partner.businessType] || partner.businessType}
                </span>
              )}
            </div>
            {success && <h3>Request sent</h3>}
          </div>
          <button type="button" className="ghost-button icon-only" aria-label="Close" onClick={onClose}>
            <LuX aria-hidden="true" />
          </button>
        </header>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {partner.logoUrl ? (
            <img
              src={partner.logoUrl}
              alt={`${partner.name} logo`}
              style={{ width: '48px', height: '48px', objectFit: 'contain', borderRadius: '8px', flexShrink: 0 }}
              loading="lazy"
            />
          ) : (
            <span
              className="conveyancer-list__logo conveyancer-list__logo--placeholder"
              aria-hidden="true"
              style={{ flexShrink: 0 }}
            >
              {(partner.name || '?').slice(0, 1).toUpperCase()}
            </span>
          )}
          <div>
            <strong style={{ fontSize: '1rem' }}>{partner.name}</strong>
            {partner.tagline && (
              <p className="muted" style={{ margin: '0.15rem 0 0', fontSize: '0.9rem' }}>{partner.tagline}</p>
            )}
          </div>
        </div>

        {partner.description && (
          <p>{partner.description}</p>
        )}

        {partner.ratingProvider === 'trustpilot' && partner.trustpilotId && (
          <TrustpilotWidget businessUnitId={partner.trustpilotId} />
        )}
        {partner.ratingProvider === 'reviews_io' && partner.reviewsIoId && (
          <ReviewsIoWidget storeId={partner.reviewsIoId} />
        )}
        {partner.ratingProvider === 'feefo' && partner.feefoId && (
          <FeefoWidget merchantId={partner.feefoId} />
        )}

        {success ? (
          <div className="seller-panel" style={{ display: 'grid', gap: '0.75rem' }}>
            <p>{successMessage ?? `${partner.name} will be in touch shortly.`}</p>
            <button type="button" className="ghost-button" onClick={onClose}>Close</button>
          </div>
        ) : (
          <form onSubmit={onSubmit} noValidate style={{ display: 'grid', gap: '0.75rem' }}>
            <label className="form-label">
              Your name
              <input
                type="text"
                className="form-input"
                value={form.name}
                onChange={(e) => onFormChange('name', e.target.value)}
                required
                autoComplete="name"
              />
            </label>

            <label className="form-label">
              Email address
              <input
                type="email"
                className="form-input"
                value={form.email}
                onChange={(e) => onFormChange('email', e.target.value)}
                required
                autoComplete="email"
              />
            </label>

            <label className="form-label">
              Phone number
              <input
                type="tel"
                className="form-input"
                value={form.phone}
                onChange={(e) => onFormChange('phone', e.target.value)}
                autoComplete="tel"
              />
            </label>

            {error && <p className="error-text">{error}</p>}

            <button
              type="submit"
              className="primary-button"
              disabled={submitting || !form.name || !form.email}
            >
              {submitting ? 'Sending…' : 'Request callback'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

export default PartnerAdvertModal
